module.exports = __webpack_public_path__ + "static/img/pattern_doc.4a35ddf3.png";